/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * An enumeration.
 */
export const AppModelsLedgersTokenType = {
  Nns: "nns",
  Sns: "sns",
  ChainKey: "chain_key",
  Tcycles: "tcycles",
} as const;
/**
 * An enumeration.
 */
export type AppModelsLedgersTokenType = ClosedEnum<
  typeof AppModelsLedgersTokenType
>;

/** @internal */
export const AppModelsLedgersTokenType$inboundSchema: z.ZodNativeEnum<
  typeof AppModelsLedgersTokenType
> = z.nativeEnum(AppModelsLedgersTokenType);

/** @internal */
export const AppModelsLedgersTokenType$outboundSchema: z.ZodNativeEnum<
  typeof AppModelsLedgersTokenType
> = AppModelsLedgersTokenType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppModelsLedgersTokenType$ {
  /** @deprecated use `AppModelsLedgersTokenType$inboundSchema` instead. */
  export const inboundSchema = AppModelsLedgersTokenType$inboundSchema;
  /** @deprecated use `AppModelsLedgersTokenType$outboundSchema` instead. */
  export const outboundSchema = AppModelsLedgersTokenType$outboundSchema;
}
